import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PaginaDto} from "../../../../../dto/util/pagina-dto";
import {ExpedienteDto} from "../../../../../dto/expediente/expediente.dto";
import {
  LiquidacionJudicialDTO,
  RespuestaDTO,
  RespuestaEliminarDTO,
  TablaProfesionalesDTO
} from "../models/liquidacion-judicial-DTO";
import {environment} from "../../../../../../environments/environment";
import {FormFieldOption} from "../../../../../dto/util/form-field";

@Injectable({
  providedIn: 'root'
})
export class LiquidacionJudicialService {

  private apiUrl = `${environment.apiUrl}/supersociedades/lji`;
  private urlProfesionales = `${environment.apiUrl}/insolvencia`;
  constructor(
    private http: HttpClient
  ) { }

  liqJudicialPNC(proceso: LiquidacionJudicialDTO){
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}/pnc`,
      proceso
    );
  }

  sociedad(proceso: LiquidacionJudicialDTO){
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}/sociedad`,
      proceso
    );
  }

  sucursalExtranjera(proceso: LiquidacionJudicialDTO){
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}/sucursal`,
      proceso
    );
  }

  liqJudicialPNNC(proceso: LiquidacionJudicialDTO){
    return this.http.post<RespuestaDTO>(
      `${this.apiUrl}/pnnc`,
      proceso
    );
  }

  listaRevisores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/revisores-fiscales?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaApoderados(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/apoderados?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaContadores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/contadores?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaRepresentantes(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/representantes-legales?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleRevisores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/revisores-fiscales/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleApoderados(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/apoderados/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleContadores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/contadores/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleRepresentantes(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/representantes-legales/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  eliminarRevisor(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-revisor?id=${id}`,
      {}
    );
  }
  eliminarApoderado(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-apoderado?id=${id}`,
      {}
    );
  }
  eliminarContador(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-contador?id=${id}`,
      {}
    );
  }
  eliminarRepresentante(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-representante?id=${id}`,
      {}
    );
  }
}
